export default {"src":"/_next/static/media/bell.daf61e8e.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};